import React, { Component } from 'react';

class StepperControl extends Component {

    handleDecrement = () => {
        const step = this.props.step || 1;
        this.props.onChange((this.props.value || 0) - step);
    }

    handleIncrement = () => {
        const step = this.props.step || 1;
        this.props.onChange((this.props.value || 0) + step);
    }

    handleInputChange = (e) => {
        const val = parseFloat(e.target.value);
        if (!isNaN(val)) {
            this.props.onChange(val);
        }
    }

    render() {
        const { label, value } = this.props;

        return (
            <div className="mb-1">
                {label && <label className="block text-xs text-gray-500 mb-1">{label}</label>}
                <div className="flex items-center">
                    <button
                        type="button"
                        className="px-2 py-0.5 bg-gray-100 border border-gray-300 rounded-l text-gray-600 hover:bg-gray-200 text-sm"
                        onClick={this.handleDecrement}
                    >
                        -
                    </button>
                    <input
                        type="number"
                        className="w-16 text-center text-sm border-t border-b border-gray-300 py-0.5 focus:outline-hidden"
                        value={typeof value === 'number' ? Math.round(value) : 0}
                        onChange={this.handleInputChange}
                    />
                    <button
                        type="button"
                        className="px-2 py-0.5 bg-gray-100 border border-gray-300 rounded-r text-gray-600 hover:bg-gray-200 text-sm"
                        onClick={this.handleIncrement}
                    >
                        +
                    </button>
                </div>
            </div>
        );
    }
}

export default StepperControl;
